<div class="toast-container">
  @for (t of toast.toasts(); track t.id) {
    <div class="toast toast-{{ t.type }}">
      <span class="toast-icon">
        @if (t.type === 'success') { ✓ }
        @else if (t.type === 'error') { ✕ }
        @else { ℹ }
      </span>
      <span class="toast-msg">{{ t.message }}</span>
      <button class="toast-close" (click)="toast.remove(t.id)">×</button>
    </div>
  }
</div>
